export const Functions = {
  create: true,
  delete: true,
  detail: true,
  search: false
};
export const PageName = '自动划转配置';